import {DISPLAY_LOGIN_LOADING, HIDE_LOGIN_LOADING} from '/enum/loading.enum';
import {createPromisedAction} from '/util/action.util';

export const displayLoginLoading = createPromisedAction(DISPLAY_LOGIN_LOADING);
export const hideLoginLoading = createPromisedAction(HIDE_LOGIN_LOADING);
